import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { ApolloProviderContainer } from './apollo-provider-container';
import { useInviteCodeAuth } from './hooks/use-invite-code-auth';
import GithubCodingPage from './pages/github-coding/gihub-coding-page';
import InterviewPage from './pages/interview/interview-page';
import RlEnvironmentPage from './pages/rl-environment/rl-environment-page';
import { MediaDevicesProvider } from './providers/media-devices-provider';
import { ScreenRecorderProvider } from './providers/screen-recorder-provider';
import { ProvidersContainer } from './providers-container';
import { Trackers } from './trackers';

const AppContent: React.FC = () => {
  const { accessToken } = useInviteCodeAuth();

  if (!accessToken) {
    return null;
  }

  return (
    <ScreenRecorderProvider>
      <Routes>
        <Route
          path='/interviews/:id'
          element={
            <MediaDevicesProvider>
              <InterviewPage accessToken={accessToken} />
            </MediaDevicesProvider>
          }
        />
        <Route
          path='/github-coding-assessments/:id'
          element={<GithubCodingPage />}
        />
        <Route
          path='/rl-environment-assessments/:id'
          element={<RlEnvironmentPage />}
        />
      </Routes>
    </ScreenRecorderProvider>
  );
};

export const App = () => {
  return (
    <React.StrictMode>
      <ApolloProviderContainer>
        <ProvidersContainer>
          <AppContent />
          <Trackers />
        </ProvidersContainer>
      </ApolloProviderContainer>
    </React.StrictMode>
  );
};
